import React from "react";
import "./Sustainability.css";

const SustainabilityPage = () => {
  return (
    <div className="sustainability-page">
      {/* Header Section */}
      <div className="header-section">
        <div className="container">
          <div className="header-content">
            <h1 className="main-title">Sustainability & Carbon Neutrality</h1>
          </div>

          {/* Intro paragraph */}
          <div className="welcome-section">
            <p className="welcome-text">
At Peak Mobile Kenya, we are committed to building a sustainable digital future. As a mobile and digital services provider, we recognise our responsibility to reduce our environmental impact while supporting Kenya’s national climate goals.
            </p>
          </div>
        </div>
      </div>

      {/* Commitments Section */}
      <div className="commitments-section">
        <div className="container">
          <div className="commitments-wrapper">
            <h2 className="section-title">Our Commitments</h2>

            <div className="commitments-grid">
              {/* 1 */}
              <div className="commitment-card">
                <div className="commitment-number">1</div>
                <h3 className="commitment-title">Sustainable Operations</h3>
                <ul className="commitment-list">
                  <li>
Transition to digital-first processes (eSIM, paperless onboarding, digital receipts).
                  </li>
                  <li>
Adoption of energy-efficient technologies in our offices and network systems.
                  </li>
                </ul>
              </div>

              {/* 2 */}
              <div className="commitment-card">
                <div className="commitment-number">2</div>
                <h3 className="commitment-title">
                  Responsible Procurement & Waste Management
                </h3>
                <ul className="commitment-list">
                  <li>
Preference for eco-certified products and environmentally responsible suppliers.
                  </li>
                  <li>
Reduction of single-use plastics and implementation of a licensed e-waste recycling program.
                  </li>
                  <li>Device take-back and recycling for devices.</li>
                </ul>
              </div>

              {/* 3 */}
              <div className="commitment-card">
                <div className="commitment-number">3</div>
                <h3 className="commitment-title">Green Digital Infrastructure</h3>
                <ul className="commitment-list">
                  <li>
Support for shared infrastructure and energy-efficient telecom technologies.
                  </li>
                  <li>
Collaboration with partners to expand sustainable digital connectivity in Kenya.
                  </li>
                </ul>
              </div>

              {/* 4 */}
              <div className="commitment-card">
                <div className="commitment-number">4</div>
                <h3 className="commitment-title">
                  Offsetting & Community Impact
                </h3>
                <ul className="commitment-list">
                  <li>
Where emissions cannot be eliminated, we invest in high-quality local offsets, including reforestation, mangrove restoration, and community solar initiatives.
                  </li>
                </ul>
              </div>

              {/* 5 */}
              <div className="commitment-card">
                <div className="commitment-number">5</div>
                <h3 className="commitment-title">
                  Accountability & Transparency
                </h3>
                <ul className="commitment-list">
                  <li>
Oversight and annual public reporting.
                  </li>
                  <li>
Continuous improvement guided by Kenya’s Climate Change Act, global standards, and emerging innovations.
                  </li>
                </ul>
              </div>
            </div>

            {/* Closing note */}
            <div className="closing-section">
              <p className="closing-text">
Peak Mobile is committed to a greener, more sustainable digital ecosystem, today and for future generations.
              </p>

              <p className="closing-subtext">
                For sustainability enquiries or reporting matters, please contact{" "}
                <a
                  href="mailto:chat@peakmobile.co.ke"
                  className="email-link"
                >
                  chat@peakmobile.co.ke
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityPage;
